export default function () {
  document.querySelectorAll('[data-dropdown-toggle]').forEach(button => {
    button.addEventListener('click', e => {
      const dropdown = document.querySelector(`#${button.dataset.dropdown}`)
      button.dataset.slide === undefined ? dropdown.classList.toggle('is-opened') : dropdown.slideToggle()

      document.querySelectorAll(`[data-dropdown-toggle][data-dropdown="${button.dataset.dropdown}"]`).forEach(button => {
        button.classList.toggle('is-opened')
      })
    })
  })
  document.querySelectorAll('[data-dropdown-hide]').forEach(button => {
    button.addEventListener('click', e => {
      button.remove()
    })
  })
}
